<template>
  <!--begin::Aside Menu-->
  <div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper">
    <!--begin::Menu Container-->
    <div
      id="kt_aside_menu"
      class="aside-menu my-4"
      data-menu-vertical="1"
      data-menu-scroll="1"
      data-menu-dropdown-timeout="500"
    >
      <!--begin::Menu Nav-->
      <ul class="menu-nav">
        <li class="menu-item menu-item-active" aria-haspopup="true">
          <!-- <a href="index.html" class="menu-link"> -->
          <router-link to="/" class="menu-link">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Layers.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M12.9336061,16.072447 L19.36,10.9564761 L19.5181585,10.8312381 C20.1676248,10.3169571 20.2772143,9.3735535 19.7629333,8.72408713 C19.6917232,8.63415859 19.6104327,8.55269514 19.5206557,8.48129411 L12.9336854,3.24257445 C12.3871201,2.80788259 11.6128799,2.80788259 11.0663146,3.24257445 L4.47482784,8.48488609 C3.82645598,9.00054628 3.71887192,9.94418071 4.23453211,10.5925526 C4.30500305,10.6811601 4.38527899,10.7615046 4.47382636,10.8320511 L4.63,10.9564761 L11.0659024,16.0730648 C11.6126744,16.5077525 12.3871218,16.5074963 12.9336061,16.072447 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                  />
                  <path
                    d="M11.0563554,18.6706981 L5.33593024,14.122919 C4.94553994,13.8125559 4.37746707,13.8774308 4.06710397,14.2678211 C4.06471678,14.2708238 4.06234874,14.2738418 4.06,14.2768747 L4.06,14.2768747 C3.75257288,14.6738539 3.82516916,15.244888 4.22214834,15.5523151 C4.22358765,15.5534297 4.2250303,15.55454 4.22647627,15.555646 L11.0872776,20.8031356 C11.6250734,21.2144692 12.371757,21.2145375 12.909628,20.8033023 L19.7677785,15.559828 C20.1693192,15.2528257 20.2459576,14.6784381 19.9389553,14.2768974 C19.9376429,14.2751809 19.9363245,14.2734691 19.935,14.2717619 L19.935,14.2717619 C19.6266937,13.8743807 19.0546209,13.8021712 18.6572397,14.1104775 C18.654352,14.112718 18.6514778,14.1149757 18.6486172,14.1172508 L12.9235044,18.6705218 C12.377022,19.1051477 11.6029199,19.1052208 11.0563554,18.6706981 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Dashboard</span>
            <!-- </a> -->
          </router-link>
        </li>
        <li class="menu-section">
          <h4 class="menu-text text-light" style="color: #fce436">
            MENU PRINCIPAL
          </h4>
          <i class="svg-icon-warning menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>

        <!-- 

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/agenda')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <router-link to="/agenda" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M7.14319965,19.3575259 C7.67122143,19.7615175 8.25104409,20.1012165 8.87097532,20.3649307 L7.89205065,22.0604779 C7.61590828,22.5387706 7.00431787,22.7026457 6.52602525,22.4265033 C6.04773263,22.150361 5.88385747,21.5387706 6.15999985,21.0604779 L7.14319965,19.3575259 Z M15.1367085,20.3616573 C15.756345,20.0972995 16.3358198,19.7569961 16.8634386,19.3524415 L17.8320512,21.0301278 C18.1081936,21.5084204 17.9443184,22.1200108 17.4660258,22.3961532 C16.9877332,22.6722956 16.3761428,22.5084204 16.1000004,22.0301278 L15.1367085,20.3616573 Z"
                    fill="#000000"
                  />
                  <path
                    d="M12,21 C7.581722,21 4,17.418278 4,13 C4,8.581722 7.581722,5 12,5 C16.418278,5 20,8.581722 20,13 C20,17.418278 16.418278,21 12,21 Z M19.068812,3.25407593 L20.8181344,5.00339833 C21.4039208,5.58918477 21.4039208,6.53893224 20.8181344,7.12471868 C20.2323479,7.71050512 19.2826005,7.71050512 18.696814,7.12471868 L16.9474916,5.37539627 C16.3617052,4.78960984 16.3617052,3.83986237 16.9474916,3.25407593 C17.5332781,2.66828949 18.4830255,2.66828949 19.068812,3.25407593 Z M5.29862906,2.88207799 C5.8844155,2.29629155 6.83416297,2.29629155 7.41994941,2.88207799 C8.00573585,3.46786443 8.00573585,4.4176119 7.41994941,5.00339833 L5.29862906,7.12471868 C4.71284263,7.71050512 3.76309516,7.71050512 3.17730872,7.12471868 C2.59152228,6.53893224 2.59152228,5.58918477 3.17730872,5.00339833 L5.29862906,2.88207799 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                  <path
                    d="M11.9630156,7.5 L12.0475062,7.5 C12.3043819,7.5 12.5194647,7.69464724 12.5450248,7.95024814 L13,12.5 L16.2480695,14.3560397 C16.403857,14.4450611 16.5,14.6107328 16.5,14.7901613 L16.5,15 C16.5,15.2109164 16.3290185,15.3818979 16.1181021,15.3818979 C16.0841582,15.3818979 16.0503659,15.3773725 16.0176181,15.3684413 L11.3986612,14.1087258 C11.1672824,14.0456225 11.0132986,13.8271186 11.0316926,13.5879956 L11.4644883,7.96165175 C11.4845267,7.70115317 11.7017474,7.5 11.9630156,7.5 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
            </span>
            <span class="menu-text text-light">Agenda</span>
            <i class="menu-arrow text-light"></i>
          </router-link>
        </li>

        -->

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/conta-pagar')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/conta-pagar" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="11.5"
                    y="2"
                    width="2"
                    height="4"
                    rx="1"
                  />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="11.5"
                    y="16"
                    width="2"
                    height="5"
                    rx="1"
                  />
                  <path
                    d="M15.493,8.044 C15.2143319,7.68933156 14.8501689,7.40750104 14.4005,7.1985 C13.9508311,6.98949895 13.5170021,6.885 13.099,6.885 C12.8836656,6.885 12.6651678,6.90399981 12.4435,6.942 C12.2218322,6.98000019 12.0223342,7.05283279 11.845,7.1605 C11.6676658,7.2681672 11.5188339,7.40749914 11.3985,7.5785 C11.2781661,7.74950085 11.218,7.96799867 11.218,8.234 C11.218,8.46200114 11.2654995,8.65199924 11.3605,8.804 C11.4555005,8.95600076 11.5948324,9.08899943 11.7785,9.203 C11.9621676,9.31700057 12.1806654,9.42149952 12.434,9.5165 C12.6873346,9.61150047 12.9723317,9.70966616 13.289,9.811 C13.7450023,9.96300076 14.2199975,10.1308324 14.714,10.3145 C15.2080025,10.4981676 15.6576646,10.7419985 16.063,11.046 C16.4683354,11.3500015 16.8039987,11.7268311 17.07,12.1765 C17.3360013,12.6261689 17.469,13.1866633 17.469,13.858 C17.469,14.6306705 17.3265014,15.2988305 17.0415,15.8625 C16.7564986,16.4261695 16.3733357,16.8916648 15.892,17.259 C15.4106643,17.6263352 14.8596698,17.8986658 14.239,18.076 C13.6183302,18.2533342 12.97867,18.342 12.32,18.342 C11.3573285,18.342 10.4263378,18.1741683 9.527,17.8385 C8.62766217,17.5028317 7.88033631,17.0246698 7.285,16.404 L9.413,14.238 C9.74233498,14.6433354 10.176164,14.9821653 10.7145,15.2545 C11.252836,15.5268347 11.7879973,15.663 12.32,15.663 C12.5606679,15.663 12.7949989,15.6376669 13.023,15.587 C13.2510011,15.5363331 13.4504991,15.4540006 13.6215,15.34 C13.7925009,15.2259994 13.9286662,15.0740009 14.03,14.884 C14.1313338,14.693999 14.182,14.4660013 14.182,14.2 C14.182,13.9466654 14.1186673,13.7313342 13.992,13.554 C13.8653327,13.3766658 13.6848345,13.2151674 13.4505,13.0695 C13.2161655,12.9238326 12.9248351,12.7908339 12.5765,12.6705 C12.2281649,12.5501661 11.8323355,12.420334 11.389,12.281 C10.9583312,12.141666 10.5371687,11.9770009 10.1255,11.787 C9.71383127,11.596999 9.34650161,11.3531682 9.0235,11.0555 C8.70049838,10.7578318 8.44083431,10.3968355 8.2445,9.9725 C8.04816568,9.54816454 7.95,9.03200304 7.95,8.424 C7.95,7.67666293 8.10199848,7.03700266 8.406,6.505 C8.71000152,5.97299734 9.10899753,5.53600171 9.603,5.194 C10.0970025,4.85199829 10.6543302,4.60183412 11.275,4.4435 C11.8956698,4.28516587 12.5226635,4.206 13.156,4.206 C13.9160038,4.206 14.6918294,4.34533194 15.4835,4.624 C16.2751706,4.90266806 16.9686637,5.31433061 17.564,5.859 L15.493,8.044 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Contas a pagar</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <li
          class="menu-item menu-item-submenu"
          aria-haspopup="true"
          data-menu-toggle="hover"
          v-if="hasPermission('/conta-receber')"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/conta-receber" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="11.5"
                    y="2"
                    width="2"
                    height="4"
                    rx="1"
                  />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="11.5"
                    y="16"
                    width="2"
                    height="5"
                    rx="1"
                  />
                  <path
                    d="M15.493,8.044 C15.2143319,7.68933156 14.8501689,7.40750104 14.4005,7.1985 C13.9508311,6.98949895 13.5170021,6.885 13.099,6.885 C12.8836656,6.885 12.6651678,6.90399981 12.4435,6.942 C12.2218322,6.98000019 12.0223342,7.05283279 11.845,7.1605 C11.6676658,7.2681672 11.5188339,7.40749914 11.3985,7.5785 C11.2781661,7.74950085 11.218,7.96799867 11.218,8.234 C11.218,8.46200114 11.2654995,8.65199924 11.3605,8.804 C11.4555005,8.95600076 11.5948324,9.08899943 11.7785,9.203 C11.9621676,9.31700057 12.1806654,9.42149952 12.434,9.5165 C12.6873346,9.61150047 12.9723317,9.70966616 13.289,9.811 C13.7450023,9.96300076 14.2199975,10.1308324 14.714,10.3145 C15.2080025,10.4981676 15.6576646,10.7419985 16.063,11.046 C16.4683354,11.3500015 16.8039987,11.7268311 17.07,12.1765 C17.3360013,12.6261689 17.469,13.1866633 17.469,13.858 C17.469,14.6306705 17.3265014,15.2988305 17.0415,15.8625 C16.7564986,16.4261695 16.3733357,16.8916648 15.892,17.259 C15.4106643,17.6263352 14.8596698,17.8986658 14.239,18.076 C13.6183302,18.2533342 12.97867,18.342 12.32,18.342 C11.3573285,18.342 10.4263378,18.1741683 9.527,17.8385 C8.62766217,17.5028317 7.88033631,17.0246698 7.285,16.404 L9.413,14.238 C9.74233498,14.6433354 10.176164,14.9821653 10.7145,15.2545 C11.252836,15.5268347 11.7879973,15.663 12.32,15.663 C12.5606679,15.663 12.7949989,15.6376669 13.023,15.587 C13.2510011,15.5363331 13.4504991,15.4540006 13.6215,15.34 C13.7925009,15.2259994 13.9286662,15.0740009 14.03,14.884 C14.1313338,14.693999 14.182,14.4660013 14.182,14.2 C14.182,13.9466654 14.1186673,13.7313342 13.992,13.554 C13.8653327,13.3766658 13.6848345,13.2151674 13.4505,13.0695 C13.2161655,12.9238326 12.9248351,12.7908339 12.5765,12.6705 C12.2281649,12.5501661 11.8323355,12.420334 11.389,12.281 C10.9583312,12.141666 10.5371687,11.9770009 10.1255,11.787 C9.71383127,11.596999 9.34650161,11.3531682 9.0235,11.0555 C8.70049838,10.7578318 8.44083431,10.3968355 8.2445,9.9725 C8.04816568,9.54816454 7.95,9.03200304 7.95,8.424 C7.95,7.67666293 8.10199848,7.03700266 8.406,6.505 C8.71000152,5.97299734 9.10899753,5.53600171 9.603,5.194 C10.0970025,4.85199829 10.6543302,4.60183412 11.275,4.4435 C11.8956698,4.28516587 12.5226635,4.206 13.156,4.206 C13.9160038,4.206 14.6918294,4.34533194 15.4835,4.624 C16.2751706,4.90266806 16.9686637,5.31433061 17.564,5.859 L15.493,8.044 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Contas a receber</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/extrato')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/extrato" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="7"
                    y="4"
                    width="10"
                    height="4"
                  />
                  <path
                    d="M7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,20 C19,21.1045695 18.1045695,22 17,22 L7,22 C5.8954305,22 5,21.1045695 5,20 L5,4 C5,2.8954305 5.8954305,2 7,2 Z M8,12 C8.55228475,12 9,11.5522847 9,11 C9,10.4477153 8.55228475,10 8,10 C7.44771525,10 7,10.4477153 7,11 C7,11.5522847 7.44771525,12 8,12 Z M8,16 C8.55228475,16 9,15.5522847 9,15 C9,14.4477153 8.55228475,14 8,14 C7.44771525,14 7,14.4477153 7,15 C7,15.5522847 7.44771525,16 8,16 Z M12,12 C12.5522847,12 13,11.5522847 13,11 C13,10.4477153 12.5522847,10 12,10 C11.4477153,10 11,10.4477153 11,11 C11,11.5522847 11.4477153,12 12,12 Z M12,16 C12.5522847,16 13,15.5522847 13,15 C13,14.4477153 12.5522847,14 12,14 C11.4477153,14 11,14.4477153 11,15 C11,15.5522847 11.4477153,16 12,16 Z M16,12 C16.5522847,12 17,11.5522847 17,11 C17,10.4477153 16.5522847,10 16,10 C15.4477153,10 15,10.4477153 15,11 C15,11.5522847 15.4477153,12 16,12 Z M16,16 C16.5522847,16 17,15.5522847 17,15 C17,14.4477153 16.5522847,14 16,14 C15.4477153,14 15,14.4477153 15,15 C15,15.5522847 15.4477153,16 16,16 Z M16,20 C16.5522847,20 17,19.5522847 17,19 C17,18.4477153 16.5522847,18 16,18 C15.4477153,18 15,18.4477153 15,19 C15,19.5522847 15.4477153,20 16,20 Z M8,18 C7.44771525,18 7,18.4477153 7,19 C7,19.5522847 7.44771525,20 8,20 L12,20 C12.5522847,20 13,19.5522847 13,19 C13,18.4477153 12.5522847,18 12,18 L8,18 Z M7,4 L7,8 L17,8 L17,4 L7,4 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Extrato</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>
        <!-- 
        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/servico')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >-->
        <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
        <!-- <router-link to="/servico" class="menu-link menu-toggle">
        <span class="svg-icon svg-icon-warning menu-icon">-->
        <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
        <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                  <path
                    d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z"
                    fill="#000000"
                  />
                  <rect fill="#000000" opacity="0.3" x="10" y="9" width="7" height="2" rx="1" />
                  <rect fill="#000000" opacity="0.3" x="7" y="9" width="2" height="2" rx="1" />
                  <rect fill="#000000" opacity="0.3" x="7" y="13" width="2" height="2" rx="1" />
                  <rect fill="#000000" opacity="0.3" x="10" y="13" width="7" height="2" rx="1" />
                  <rect fill="#000000" opacity="0.3" x="7" y="17" width="2" height="2" rx="1" />
                  <rect fill="#000000" opacity="0.3" x="10" y="17" width="7" height="2" rx="1" />
                </g>
        </svg>-->
        <!--end::Svg Icon-->
        <!-- </span>
            <span class="menu-text text-light">Serviços</span>
        <i class="menu-arrow text-light"></i>-->
        <!-- </a> -->
        <!-- </router-link>
        </li>-->

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/orcamento')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/orcamento" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M8,13.1668961 L20.4470385,11.9999863 L8,10.8330764 L8,5.77181995 C8,5.70108058 8.01501031,5.63114635 8.04403925,5.56663761 C8.15735832,5.31481744 8.45336217,5.20254012 8.70518234,5.31585919 L22.545552,11.5440255 C22.6569791,11.5941677 22.7461882,11.6833768 22.7963304,11.794804 C22.9096495,12.0466241 22.7973722,12.342628 22.545552,12.455947 L8.70518234,18.6841134 C8.64067359,18.7131423 8.57073936,18.7281526 8.5,18.7281526 C8.22385763,18.7281526 8,18.504295 8,18.2281526 L8,13.1668961 Z"
                    fill="#000000"
                  />
                  <path
                    d="M4,16 L5,16 C5.55228475,16 6,16.4477153 6,17 C6,17.5522847 5.55228475,18 5,18 L4,18 C3.44771525,18 3,17.5522847 3,17 C3,16.4477153 3.44771525,16 4,16 Z M1,11 L5,11 C5.55228475,11 6,11.4477153 6,12 C6,12.5522847 5.55228475,13 5,13 L1,13 C0.44771525,13 6.76353751e-17,12.5522847 0,12 C-6.76353751e-17,11.4477153 0.44771525,11 1,11 Z M4,6 L5,6 C5.55228475,6 6,6.44771525 6,7 C6,7.55228475 5.55228475,8 5,8 L4,8 C3.44771525,8 3,7.55228475 3,7 C3,6.44771525 3.44771525,6 4,6 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Orçamentos</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/orcamento')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/arquivo" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M8,13.1668961 L20.4470385,11.9999863 L8,10.8330764 L8,5.77181995 C8,5.70108058 8.01501031,5.63114635 8.04403925,5.56663761 C8.15735832,5.31481744 8.45336217,5.20254012 8.70518234,5.31585919 L22.545552,11.5440255 C22.6569791,11.5941677 22.7461882,11.6833768 22.7963304,11.794804 C22.9096495,12.0466241 22.7973722,12.342628 22.545552,12.455947 L8.70518234,18.6841134 C8.64067359,18.7131423 8.57073936,18.7281526 8.5,18.7281526 C8.22385763,18.7281526 8,18.504295 8,18.2281526 L8,13.1668961 Z"
                    fill="#000000"
                  />
                  <path
                    d="M4,16 L5,16 C5.55228475,16 6,16.4477153 6,17 C6,17.5522847 5.55228475,18 5,18 L4,18 C3.44771525,18 3,17.5522847 3,17 C3,16.4477153 3.44771525,16 4,16 Z M1,11 L5,11 C5.55228475,11 6,11.4477153 6,12 C6,12.5522847 5.55228475,13 5,13 L1,13 C0.44771525,13 6.76353751e-17,12.5522847 0,12 C-6.76353751e-17,11.4477153 0.44771525,11 1,11 Z M4,6 L5,6 C5.55228475,6 6,6.44771525 6,7 C6,7.55228475 5.55228475,8 5,8 L4,8 C3.44771525,8 3,7.55228475 3,7 C3,6.44771525 3.44771525,6 4,6 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Arquivos</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <li
          class="menu-item menu-item-submenu"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <a href="javascript:;" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="17"
                    y="4"
                    width="3"
                    height="13"
                    rx="1.5"
                  />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="12"
                    y="9"
                    width="3"
                    height="8"
                    rx="1.5"
                  />
                  <path
                    d="M5,19 L20,19 C20.5522847,19 21,19.4477153 21,20 C21,20.5522847 20.5522847,21 20,21 L4,21 C3.44771525,21 3,20.5522847 3,20 L3,4 C3,3.44771525 3.44771525,3 4,3 C4.55228475,3 5,3.44771525 5,4 L5,19 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                  />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="7"
                    y="11"
                    width="3"
                    height="6"
                    rx="1.5"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Relatórios</span>
            <i class="menu-arrow text-light"></i>
          </a>
          <div class="menu-submenu">
            <i class="menu-arrow text-light"></i>
            <ul class="menu-subnav">
              <li
                class="menu-item"
                v-if="hasPermission('/relatorio/fluxo-diario')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href class="menu-link"> -->
                <router-link to="/relatorio/fluxo-diario" class="menu-link">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Fluxo diário</span>
                  <!-- </a> -->
                </router-link>
              </li>

              <li
                class="menu-item"
                aria-haspopup="true"
                v-if="hasPermission('/relatorio/fluxo-mensal')"
              >
                <router-link
                  to="/relatorio/fluxo-mensal"
                  class="menu-link menu-toggle"
                >
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Fluxo mensal</span>
                  <span class="menu-label"></span>
                </router-link>
              </li>
              <li
                class="menu-item"
                aria-haspopup="true"
                v-if="hasPermission('/relatorio/analise-pagar')"
              >
                <!-- <a href class="menu-link"> -->
                <router-link to="/relatorio/analise-pagar" class="menu-link">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light"
                    >Análise de pagamentos</span
                  >
                  <!-- </a> -->
                </router-link>
              </li>
              <li
                class="menu-item"
                aria-haspopup="true"
                v-if="hasPermission('/relatorio/analise-receber')"
              >
                <!-- <a href class="menu-link"> -->
                <router-link to="/relatorio/analise-receber" class="menu-link">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light"
                    >Análise de recebimento</span
                  >
                  <!-- </a> -->
                </router-link>
              </li>
              <li
                class="menu-item"
                aria-haspopup="true"
                v-if="hasPermission('/relatorio/venda-cliente')"
              >
                <router-link
                  to="/relatorio/venda-cliente"
                  class="menu-link menu-toggle"
                >
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Venda por Cliente</span>
                  <span class="menu-label"></span>
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <li class="menu-section">
          <h4 class="menu-text text-light" style="color: #fce436">CADASTROS</h4>
          <i class="svg-icon-warning menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>

        <li
          class="menu-item menu-item-submenu"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <a href="javascript:;" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Bucket.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <rect
                    fill="#000000"
                    opacity="0.3"
                    x="4"
                    y="4"
                    width="4"
                    height="4"
                    rx="1"
                  />
                  <path
                    d="M5,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,13 C8,13.5522847 7.55228475,14 7,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M11,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,7 C14,7.55228475 13.5522847,8 13,8 L11,8 C10.4477153,8 10,7.55228475 10,7 L10,5 C10,4.44771525 10.4477153,4 11,4 Z M11,10 L13,10 C13.5522847,10 14,10.4477153 14,11 L14,13 C14,13.5522847 13.5522847,14 13,14 L11,14 C10.4477153,14 10,13.5522847 10,13 L10,11 C10,10.4477153 10.4477153,10 11,10 Z M17,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,7 C20,7.55228475 19.5522847,8 19,8 L17,8 C16.4477153,8 16,7.55228475 16,7 L16,5 C16,4.44771525 16.4477153,4 17,4 Z M17,10 L19,10 C19.5522847,10 20,10.4477153 20,11 L20,13 C20,13.5522847 19.5522847,14 19,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,11 C16,10.4477153 16.4477153,10 17,10 Z M5,16 L7,16 C7.55228475,16 8,16.4477153 8,17 L8,19 C8,19.5522847 7.55228475,20 7,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,17 C4,16.4477153 4.44771525,16 5,16 Z M11,16 L13,16 C13.5522847,16 14,16.4477153 14,17 L14,19 C14,19.5522847 13.5522847,20 13,20 L11,20 C10.4477153,20 10,19.5522847 10,19 L10,17 C10,16.4477153 10.4477153,16 11,16 Z M17,16 L19,16 C19.5522847,16 20,16.4477153 20,17 L20,19 C20,19.5522847 19.5522847,20 19,20 L17,20 C16.4477153,20 16,19.5522847 16,19 L16,17 C16,16.4477153 16.4477153,16 17,16 Z"
                    fill="#000000"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Cadastros</span>
            <i class="menu-arrow text-light"></i>
          </a>
          <div class="menu-submenu">
            <i class="menu-arrow text-light"></i>
            <ul class="menu-subnav">
              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/cliente')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link to="/cliente" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light"
                    >Clientes / Fornecedores</span
                  >
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>

              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/funcionario')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link to="/funcionario" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Funcionários</span>
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>

              <!-- <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/fornecedor')"
          aria-haspopup="true"
          data-menu-toggle="hover"
              >-->
              <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
              <!-- <router-link to="/fornecedor" class="menu-link menu-toggle">
              <span class="svg-icon svg-icon-warning menu-icon">-->
              <!--begin::Svg Icon | path:assets/media/svg/icons/Layout/Layout-4-blocks.svg-->
              <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M3.5,3 L5,3 L5,19.5 C5,20.3284271 4.32842712,21 3.5,21 L3.5,21 C2.67157288,21 2,20.3284271 2,19.5 L2,4.5 C2,3.67157288 2.67157288,3 3.5,3 Z"
                    fill="#000000"
                  />
                  <path
                    d="M6.99987583,2.99995344 L19.754647,2.99999303 C20.3069317,2.99999474 20.7546456,3.44771138 20.7546439,3.99999613 C20.7546431,4.24703684 20.6631995,4.48533385 20.497938,4.66895776 L17.5,8 L20.4979317,11.3310353 C20.8673908,11.7415453 20.8341123,12.3738351 20.4236023,12.7432941 C20.2399776,12.9085564 20.0016794,13 19.7546376,13 L6.99987583,13 L6.99987583,2.99995344 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                </g>
              </svg>-->
              <!--end::Svg Icon-->
              <!-- </span>
            <span class="menu-text text-light">Fornecedores</span>
              <i class="menu-arrow text-light"></i>-->
              <!-- </a> -->
              <!-- </router-link>
              </li>-->

              <!-- <li class="menu-item menu-item-submenu"  aria-haspopup="true" data-menu-toggle="hover">
          <a href="javascript:;" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
             
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <rect fill="#000000" opacity="0.3" x="2" y="5" width="20" height="14" rx="2" />
                  <rect fill="#000000" x="2" y="8" width="20" height="3" />
                  <rect fill="#000000" opacity="0.3" x="16" y="14" width="4" height="2" rx="1" />
                </g>
              </svg>
              
            </span>
            <span class="menu-text text-light">Conta Bancária</span>
            <i class="menu-arrow text-light"></i>
          </a>
              </li>-->

              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/categoria')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link to="/categoria" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Categorias</span>
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>

              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/servico')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link to="/servico" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Serviços</span>
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>

              <!-- <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/tipo-recebimento')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <router-link to="/tipo-recebimento" class="menu-link menu-toggle">
              <span class="svg-icon svg-icon-warning menu-icon">-->
              <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Bucket.svg-->
              <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <rect x="0" y="0" width="24" height="24" />
                  <rect fill="#000000" opacity="0.3" x="4" y="4" width="4" height="4" rx="1" />
                  <path
                    d="M5,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,13 C8,13.5522847 7.55228475,14 7,14 L5,14 C4.44771525,14 4,13.5522847 4,13 L4,11 C4,10.4477153 4.44771525,10 5,10 Z M11,4 L13,4 C13.5522847,4 14,4.44771525 14,5 L14,7 C14,7.55228475 13.5522847,8 13,8 L11,8 C10.4477153,8 10,7.55228475 10,7 L10,5 C10,4.44771525 10.4477153,4 11,4 Z M11,10 L13,10 C13.5522847,10 14,10.4477153 14,11 L14,13 C14,13.5522847 13.5522847,14 13,14 L11,14 C10.4477153,14 10,13.5522847 10,13 L10,11 C10,10.4477153 10.4477153,10 11,10 Z M17,4 L19,4 C19.5522847,4 20,4.44771525 20,5 L20,7 C20,7.55228475 19.5522847,8 19,8 L17,8 C16.4477153,8 16,7.55228475 16,7 L16,5 C16,4.44771525 16.4477153,4 17,4 Z M17,10 L19,10 C19.5522847,10 20,10.4477153 20,11 L20,13 C20,13.5522847 19.5522847,14 19,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,11 C16,10.4477153 16.4477153,10 17,10 Z M5,16 L7,16 C7.55228475,16 8,16.4477153 8,17 L8,19 C8,19.5522847 7.55228475,20 7,20 L5,20 C4.44771525,20 4,19.5522847 4,19 L4,17 C4,16.4477153 4.44771525,16 5,16 Z M11,16 L13,16 C13.5522847,16 14,16.4477153 14,17 L14,19 C14,19.5522847 13.5522847,20 13,20 L11,20 C10.4477153,20 10,19.5522847 10,19 L10,17 C10,16.4477153 10.4477153,16 11,16 Z M17,16 L19,16 C19.5522847,16 20,16.4477153 20,17 L20,19 C20,19.5522847 19.5522847,20 19,20 L17,20 C16.4477153,20 16,19.5522847 16,19 L16,17 C16,16.4477153 16.4477153,16 17,16 Z"
                    fill="#000000"
                  />
                </g>
              </svg>-->
              <!--end::Svg Icon-->
              <!-- </span>
            <span class="menu-text text-light">Tipo de Recebimentos</span>
              <i class="menu-arrow text-light"></i>-->
              <!-- </a> -->
              <!-- </router-link>
              </li>-->

              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/forma-pagamento')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link
                  to="/forma-pagamento"
                  class="menu-link menu-toggle"
                >
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Formas de Pagamentos</span>
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>
              <li
                class="menu-item menu-item-submenu"
                v-if="hasPermission('/periodicidade')"
                aria-haspopup="true"
                data-menu-toggle="hover"
              >
                <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
                <router-link to="/periodicidade" class="menu-link menu-toggle">
                  <i class="menu-bullet menu-bullet-dot">
                    <span></span>
                  </i>
                  <span class="menu-text text-light">Periodicidade</span>
                  <i class="menu-arrow text-light"></i>
                  <!-- </a> -->
                </router-link>
              </li>
            </ul>
          </div>
        </li>

        <li class="menu-section">
          <h4 class="menu-text text-light" style="color: #fce436">ACESSOS</h4>
          <i class="svg-icon-warning menu-icon ki ki-bold-more-hor icon-md"></i>
        </li>

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/empresa')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/empresa" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Bucket.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <rect x="0" y="0" width="24" height="24" />
                  <path
                    d="M13.5,21 L13.5,18 C13.5,17.4477153 13.0522847,17 12.5,17 L11.5,17 C10.9477153,17 10.5,17.4477153 10.5,18 L10.5,21 L5,21 L5,4 C5,2.8954305 5.8954305,2 7,2 L17,2 C18.1045695,2 19,2.8954305 19,4 L19,21 L13.5,21 Z M9,4 C8.44771525,4 8,4.44771525 8,5 L8,6 C8,6.55228475 8.44771525,7 9,7 L10,7 C10.5522847,7 11,6.55228475 11,6 L11,5 C11,4.44771525 10.5522847,4 10,4 L9,4 Z M14,4 C13.4477153,4 13,4.44771525 13,5 L13,6 C13,6.55228475 13.4477153,7 14,7 L15,7 C15.5522847,7 16,6.55228475 16,6 L16,5 C16,4.44771525 15.5522847,4 15,4 L14,4 Z M9,8 C8.44771525,8 8,8.44771525 8,9 L8,10 C8,10.5522847 8.44771525,11 9,11 L10,11 C10.5522847,11 11,10.5522847 11,10 L11,9 C11,8.44771525 10.5522847,8 10,8 L9,8 Z M9,12 C8.44771525,12 8,12.4477153 8,13 L8,14 C8,14.5522847 8.44771525,15 9,15 L10,15 C10.5522847,15 11,14.5522847 11,14 L11,13 C11,12.4477153 10.5522847,12 10,12 L9,12 Z M14,12 C13.4477153,12 13,12.4477153 13,13 L13,14 C13,14.5522847 13.4477153,15 14,15 L15,15 C15.5522847,15 16,14.5522847 16,14 L16,13 C16,12.4477153 15.5522847,12 15,12 L14,12 Z"
                    fill="#000000"
                  />
                  <rect
                    fill="#FFFFFF"
                    x="13"
                    y="8"
                    width="3"
                    height="3"
                    rx="1"
                  />
                  <path
                    d="M4,21 L20,21 C20.5522847,21 21,21.4477153 21,22 L21,22.4 C21,22.7313708 20.7313708,23 20.4,23 L3.6,23 C3.26862915,23 3,22.7313708 3,22.4 L3,22 C3,21.4477153 3.44771525,21 4,21 Z"
                    fill="#000000"
                    opacity="0.3"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Empresas</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/usuario')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >
          <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
          <router-link to="/usuario" class="menu-link menu-toggle">
            <span class="svg-icon svg-icon-warning menu-icon">
              <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Bucket.svg-->
              <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M12,11 C9.790861,11 8,9.209139 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,9.209139 14.209139,11 12,11 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.3"
                  />
                  <path
                    d="M3.00065168,20.1992055 C3.38825852,15.4265159 7.26191235,13 11.9833413,13 C16.7712164,13 20.7048837,15.2931929 20.9979143,20.2 C21.0095879,20.3954741 20.9979143,21 20.2466999,21 C16.541124,21 11.0347247,21 3.72750223,21 C3.47671215,21 2.97953825,20.45918 3.00065168,20.1992055 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                  />
                </g>
              </svg>
              <!--end::Svg Icon-->
            </span>
            <span class="menu-text text-light">Usuários</span>
            <i class="menu-arrow text-light"></i>
            <!-- </a> -->
          </router-link>
        </li>

        <!-- <li
          class="menu-item menu-item-submenu"
          v-if="hasPermission('/perfil-acesso')"
          aria-haspopup="true"
          data-menu-toggle="hover"
        >-->
        <!-- <a href="javascript:;" class="menu-link menu-toggle"> -->
        <!-- <router-link to="/perfil-acesso" class="menu-link menu-toggle">
        <span class="svg-icon svg-icon-warning menu-icon">-->
        <!--begin::Svg Icon | path:assets/media/svg/icons/Design/Bucket.svg-->
        <!-- <svg
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                width="24px"
                height="24px"
                viewBox="0 0 24 24"
                version="1.1"
              >
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <polygon points="0 0 24 0 24 24 0 24" />
                  <path
                    d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                    opacity="0.3"
                  />
                  <path
                    d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z"
                    fill="#000000"
                    fill-rule="nonzero"
                  />
                </g>
        </svg>-->
        <!--end::Svg Icon-->
        <!-- </span>
            <span class="menu-text text-light">Perfil de acesso</span>
        <i class="menu-arrow text-light"></i>-->
        <!-- </a> -->
        <!-- </router-link>
        </li>-->
      </ul>
      <!--end::Menu Nav-->
    </div>
    <!--end::Menu Container-->
  </div>
  <!--end::Aside Menu-->
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "menu",
  computed: {
    ...mapState("auth", ["user"]),
  },
  updated() {
    window.KTLayoutAsideMenu.init("kt_aside_menu");
  },
  mounted() {
    window.KTUtil.init();
  },
  methods: {
    hasPermission(to) {
      if (this.user.funcionalidadesHabilitadas.length > 0) {
        let lista = this.user.funcionalidadesHabilitadas.map(
          (f) => f.funcionalidade.url
        );
        return lista.length
          ? lista.filter((f) => to.includes(f)).length > 0
          : true;
      } else {
        return true;
      }
    },
  },
};
</script>